import { useEffect, useState } from "react";
import { Box, IconButton, Typography, Avatar } from "@mui/material";
import "./Topbar.scss";
import { useLocation, useNavigate } from "react-router-dom";
import BookIcon from '@mui/icons-material/Book';
import ProfileMenuContainer from "components/ProfileMenu";
import Grid from "@mui/material/Grid2";
import { DOWNLOAD_USER_MANUAL } from "constant/endpoints";


function Topbar(props) {
  const { isNavbarCollapsed, account, setAccount, api } = props;
  const [currentPath, setCurrentPath] = useState("");
  const [isMenuOpen, setMenuOpen] = useState(false)
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const navigate = useNavigate();

  let location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname.split("/")[1];
    setCurrentPath(currentPath);
  }, [location]);

  const handleDownloadManual = async () => {
    try {
      const response = await api(DOWNLOAD_USER_MANUAL, { responseType: "blob" });
      if (response && response.body) {
        const blob = new Blob([response.body], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "manual_de_usuario.pdf");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error al descargar el manual:", error);
    }
  };

  const handleOpenManual = () => {
    navigate("/manual-de-uso");
  };

  return (
    <Grid
      container
      spacing={2}
      className="swt-topbar">
      <Grid
        item="true"
        size={{ xs: 12, sm: 3, md: 3 }}
        sx={{ p: "10px", display: "flex", flexDirection: "column", justifyContent: "end" }}
      >
        <a href="/" >
          <img
            alt="logo"
            src={`../../logo.svg`}
            style={{
              width: "70%",
              maxHeight: "140px",
            }}
          />
        </a>
      </Grid>
      <Grid
        item="true"
        size={{ xs: 12, sm: 9, md: 9 }}
        sx={{ width: "100%", p: "10px" }}>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            background: "linear-gradient(90deg, #E81F76 0%, #417099 50%, #00AEC3 100%)",
            p: "20px",
            justifyContent: "space-between",
            borderRadius: "15px"
          }}
        >
          <Typography
            sx={{ fontSize: "22px", ml: "10px", fontWeight: "600", fontFamily: "Encode Sans" }}
            color="#fff"
          >
            Tablero de gestión administrativa
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              /* background: "#00AEC3", */
              padding: "6px 16px",
              borderRadius: "15px",
              gap: "15px",
              position: "relative",
            }}
          >
            <Box
              sx={{ display: "flex", flexDirection: "row", alignItems: "center", mr: "10px", cursor: "pointer" }}
              onClick={handleOpenManual}
            >
              <Typography sx={{ fontSize: "1rem", fontWeight: "400", ml: "2px", color: "#fff" }}>
                Manual de uso
              </Typography>
              <BookIcon sx={{ color: "#fff" }} />
            </Box>
            {/* <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", mr: "10px", cursor: "pointer" }} onClick={handleDownloadManual}>
              <Typography sx={{ fontSize: "1rem", fontWeight: "400", ml: "2px", color: "#fff" }}>Manual de uso</Typography>
              <BookIcon sx={{ color: "#fff" }} />
            </Box> */}
            <Box
              sx={{
                display: "flex", flexDirection: "row", alignItems: "center", mr: "10px"
              }}
            >
              <Typography
                /* variant="h6" */
                sx={{
                  fontSize: "1rem",
                  fontWeight: "400",
                  marginRight: "10px",
                  fontFamily: "Encode Sans",
                  color: "#fff"
                }}
              >
                {/*Nombre de usuario en top*/}
                {account.full_name}:
              </Typography>
              <div style={{ cursor: 'pointer' }} onClick={() => setMenuOpen(!isMenuOpen)}>
                <Avatar
                  src={
                    process.env.REACT_APP_BACKEND_URL_MEDIA + account.profile_image
                  }
                  sx={{
                    width: "50px",
                    height: "35px",
                    borderRadius: "20px",
                  }}
                />
              </div>
              <ProfileMenuContainer isMenuOpen={isMenuOpen}
                setMenuOpen={setMenuOpen} />
            </Box>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}

export default Topbar;
